import apiService from "../../ApiService";

export interface DreiConfig {
  oauthConfig: {
    baseURL: string;
    clientID: string;
    redirectURL: string;
    scope: string;
  };
  crmConfig: {
    wrongCrmCustomerUrl: string;
  };
  urlConfig: {
    infoUrl?: string;
  };
}

export const dreiGetConfig = () => {
  return apiService.get<DreiConfig>({
    path: `v1/store/drei/config`,
  });
};
